/**
 * Debug page to show Clerk user info
 */

import { useAuth, useUser } from '@clerk/clerk-react';

export default function DebugUser() {
  const { userId, sessionClaims, isSignedIn } = useAuth();
  const { user } = useUser();

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Debug User Info</h1>

      <div className="card">
        <h2 className="text-xl font-semibold mb-4">Auth Status</h2>
        <pre className="bg-gray-900 p-4 rounded text-sm overflow-auto">
          {JSON.stringify(
            {
              isSignedIn,
              userId,
            },
            null,
            2
          )}
        </pre>
      </div>

      <div className="card">
        <h2 className="text-xl font-semibold mb-4">User Object</h2>
        <pre className="bg-gray-900 p-4 rounded text-sm overflow-auto">
          {JSON.stringify(
            user
              ? {
                  id: user.id,
                  emailAddresses: user.emailAddresses.map((e) => e.emailAddress),
                  firstName: user.firstName,
                  lastName: user.lastName,
                  publicMetadata: user.publicMetadata,
                  unsafeMetadata: user.unsafeMetadata,
                }
              : null,
            null,
            2
          )}
        </pre>
      </div>

      <div className="card">
        <h2 className="text-xl font-semibold mb-4">Session Claims</h2>
        <pre className="bg-gray-900 p-4 rounded text-sm overflow-auto">
          {JSON.stringify(sessionClaims, null, 2)}
        </pre>
      </div>

      <div className="card bg-yellow-900/20 border-yellow-500/30">
        <h2 className="text-xl font-semibold mb-4 text-yellow-400">Copy This Info</h2>
        <p className="mb-2 text-sm">
          Copy your Clerk User ID below to register as admin:
        </p>
        <div className="bg-gray-900 p-4 rounded">
          <code className="text-green-400 text-lg font-mono">{userId || 'Not signed in'}</code>
        </div>
      </div>
    </div>
  );
}
